module.exports = __webpack_public_path__ + "img/Upsource_icon.171f6f6a.png";